import { MobileMenuItem } from '../app/shared/interfaces/mobile-menu-item';

// export const mobileMenu: MobileMenuItem[] =
// [
//     { type: 'link', label: 'Welcome', url: '/home', children: [] },
//     { type: 'link', label: 'Profile', url: '/account/profile', children: [] },
//     { type: 'link', label: 'Wallet', url: '/account/wallet', children: [] },
//     { type: 'link', label: 'Deposit', url: '/account/deposit', children: [] },
//     { type: 'link', label: 'Withdraw', url: '/account/withdraw', children: [] },
//     { type: 'link', label: 'Transaction', url: '/account/transaction', children: [] },
//     { type: 'link', label: 'Pot Game', url: '/account/potgame', children: [] },
//     { type: 'link', label: 'Sport', url: '/account/sport', children: [] },
//     { type: 'link', label: 'Settings', url: '/account/settings', children: [] },
//     { type: 'link', label: 'Change Password', url: '/account/password', children: [] },
//     { type: 'link', label: 'Logout', url: '/account/logout', children: [] }

// ];

export const mobileMenu: MobileMenuItem[] = [
   {type: 'link', label: 'Home', url: './', children: []},

   {type: 'link', label: 'Categories', url: './shop/category/100/sanc', children: []},

   {type: 'link', label: 'Shop', url: './shop', children: [
       {type: 'link', label: 'Cart',        url: './shop/cart'},
       {type: 'link', label: 'Checkout',    url: './shop/checkout'},
       {type: 'link', label: 'Wishlist',    url: './shop/wishlist'},
       {type: 'link', label: 'Compare',     url: './shop/compare'},
       {type: 'link', label: 'Track_Order', url: './shop/track-order'}
   ]},

   {type: 'link', label: 'Account', url: './account', children: [
       {type: 'link', label: 'Login',           url: './account/login'},
       {type: 'link', label: 'Dashboard',       url: './account/dashboard'},
       {type: 'link', label: 'Edit_Profile',    url: './account/profile'},
       {type: 'link', label: 'Order_History',   url: './account/orders'},
       {type: 'link', label: 'Address_Book',    url: './account/address-list'},
       {type: 'link', label: 'Change_Password', url: './account/password'}
   ]},

   {type: 'link', label: 'Blog', url: './blog', children: [ ]},

   {type: 'link', label: 'Introduction', url: './site', children: [
       {type: 'link', label: 'About_Us',             url: './site/v/about-us/v'},
       {type: 'link', label: 'Contact_Us',           url: './site/contact-us'},
       {type: 'link', label: 'Terms_And_Conditions', url: './site/v/terms/v'},
       {type: 'link', label: 'FAQ',                  url: './site/v/faq/v'}
   ]},

   {type: 'button', label: 'Currency', children: [
     //  {type: 'button', label: 'تومان',      data: {currency: 'تومان'}},
     // {type: 'button', label: '$ US Dollar',      data: {currency: 'USD'}},
    //    {type: 'button', label: '€ Euro',           data: {currency: 'EUR'}},
    //    {type: 'button', label: '£ Pound Sterling', data: {currency: 'GBP'}},
    //    {type: 'button', label: '₽ Russian Ruble',  data: {currency: 'RUB'}}
   ]},

   {type: 'button', label: 'Language', children: [
    //   {type: 'button', label: 'فارسی', data: {language: 'FA', dir: 'rtl', symbol: 'FA'}},
     //  {type: 'button', label: 'English', data: {language: 'EN',  dir: 'ltr', symbol: 'EN'}},
    //    {type: 'button', label: 'French',  data: {language: 'FR'}},
    //    {type: 'button', label: 'German',  data: {language: 'DE'}},
    //    {type: 'button', label: 'Russian', data: {language: 'RU'}},
    //    {type: 'button', label: 'Italian', data: {language: 'IT'}}
   ]}
];
